import { render, staticRenderFns } from "./editCSG.vue?vue&type=template&id=0e1ba6f8&scoped=true"
import script from "./editCSG.vue?vue&type=script&lang=js"
export * from "./editCSG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1ba6f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1ba6f8')) {
      api.createRecord('0e1ba6f8', component.options)
    } else {
      api.reload('0e1ba6f8', component.options)
    }
    module.hot.accept("./editCSG.vue?vue&type=template&id=0e1ba6f8&scoped=true", function () {
      api.rerender('0e1ba6f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/account/editCSG.vue"
export default component.exports